// Libs
import React, { ReactElement } from 'react';
import { IconButton, Icon, ClickAwayListener } from 'ui-components';
import clsx from 'clsx';
// App
import Brand from 'app-shared/lib/layout/shared/header/brand';
import UserNavContent from '../../shared/header/user-nav-content';
import useNavContentVisibility from 'app-shared/lib/layout/shared/header/nav-content-visibility.hooks';

import styles from 'app-shared/lib/layout/shared/header/main-nav.module.scss';

const MainNav = (): ReactElement => {
  const { navContentVisible, toggleNavContentVisibility, handleClickAwayNavContent } = useNavContentVisibility();

  return (
    <nav className={styles.nav}>
      <div className={styles.header}>
        <IconButton className={styles.button} onClick={toggleNavContentVisibility} size="large">
          <Icon name="menu" color="tertiary" size="extra-large" />
        </IconButton>
        <Brand className={styles.brand} />
      </div>
      <ClickAwayListener
        onClickAway={handleClickAwayNavContent}
        mouseEvent={(navContentVisible && 'onClick') || false}
        touchEvent={(navContentVisible && 'onTouchStart') || false}
      >
        <div className={clsx(styles.content, navContentVisible && styles.visible)}>
          <UserNavContent />
        </div>
      </ClickAwayListener>
    </nav>
  );
};

export default MainNav;
